import React, {useEffect} from "react";
import DashboardFooter from "../layouts/dashboard_footer";
import {Link} from "react-router-dom";

const ClinicStart: React.FC = () => {

    useEffect(()=> {
        document.title = "Project Uzima - Institutions"

    }, []);

    const divStyle = {
        borderRadius: "3% "
    }

    return(
        <>

            <div className={"container-fluid"}>

                <div className={"row"}>

                    <div className={"col-xxl-3 col-xl-3 col-lg-3 col-md-2"}> </div>

                    <div className={"col-xxl-6 col-xl-6 col-lg-6 col-md-8"}>

                        <div className={"row mt-4"}> </div>

                        <div className={"row mt-4"}> </div>

                        <div className={"row mt-4"}> </div>

                        <div className={"row mt-4 text-center"}> <h3>Get Started - Institutions & Facilities</h3> </div>

                        <div className={"row mt-4 text-center"}>
                            <p className="text-muted">Manage your facility, staff, patients, and collaborations on Uzima Healthcare.</p>
                        </div>

                        <div className={"row mt-4"}> </div>

                        <div className={"row mt-4"}>
                            <div className={"col"}>
                                <div className="card card-animate" style={divStyle}>
                                    <div className="card-body p-4 text-center">
                                        <div className="mx-auto avatar-md mb-3">
                                            <i className="ri-login-circle-line" style={{ fontSize: '3rem', color: '#0f766e' }}></i>
                                        </div>
                                        <h5 className="card-title mb-1">Login</h5>
                                        <p className="text-muted small">Already have an account with your facility?</p>

                                        <p><Link className="btn btn-outline-primary btn-rounded btn-lg mt-2"
                                              to={"/institution/newlog"}>Login</Link></p>
                                    </div>
                                </div>
                            </div>

                            <div className={"col"}>
                                <div className="card card-animate" style={divStyle}>
                                    <div className="card-body p-4 text-center">
                                        <div className="mx-auto avatar-md mb-3">
                                            <i className="ri-hospital-line" style={{ fontSize: '3rem', color: '#0f766e' }}></i>
                                        </div>
                                        <h5 className="card-title mb-1">Register Your Facility</h5>
                                        <p className="text-muted small">New to Uzima? Register your institution or clinic.</p>

                                        <p><Link className="btn btn-outline-primary btn-rounded btn-lg mt-2"
                                              to={"/institution/newreg"}>Register</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className={"col-xxl-3 col-xl-3 col-lg-3 col-md-2"}> </div>

                </div>

            </div>

            <DashboardFooter></DashboardFooter>

        </>
    )
}

export default ClinicStart;
